var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Component, Vue, Watch, Ref } from "vue-facing-decorator";
import { ReportClient, GetReportListQuery, SortDescription, SortDirection, ReportScheduleModel, ReportSchedulePeriodEnum, UpdateReportScheduleCommand } from "@/app/api/battery-portal-api";
import ReportSchedulerManagerVue from "@/app/vues/reports/report-scheduler-manager.vue";
import ReportSchedulerWizardVue from "@/app/vues/reports/report-scheduler-wizard.vue";
import DischargeReportFilterVue from "@/app/vues/reports/discharge-report-filter.vue";
import DashboardReportFilterVue from "./dashboard-report-filter.vue";
import OhmicTrendReportFilterVue from "./ohmic-trend-filter.vue";
import DischargeActivityReportFilterVue from "./discharge-activity-report-filter.vue";
import StringLifeReportFilterVue from "./string-life-report-filter.vue";
import BlockStatusReportFilterVue from "./block-status-report-filter.vue";
import StringStatusReportFilterVue from "./string-status-report-filter.vue";
import CompanySummaryReportFilterVue from "./company-summary-report-filter.vue";
import SiteIssueSummaryReportFilterVue from "./site-issue-summary-filter.vue";
import CompanySystemsReportFilterVue from "./company-systems-report-filter.vue";
import BatteryReplacementEstimationReportFilterVue from "./battery-replacement-estimation-report-filter.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
const reportClient = new ReportClient(window.apiUrl);
let ReportManagerVue = class ReportManagerVue extends Vue {
    constructor() {
        super(...arguments);
        // singleton
        this.working = false;
        this.loaded = false;
        this.records = new Array();
        this.selectedReportItem = null;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "reportName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetReportListQuery({
            sort: this.sorter.currentSort
        });
        this.componentKey = 1;
    }
    mounted() {
        this.getReports();
    }
    getReports() {
        this.working = true;
        reportClient.getReportList(this.query).then((response) => {
            this.records = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.sort = this.sorter.currentSort;
            yield this.getReports();
        });
    }
    ;
    //Computed
    get noData() {
        return this.loaded && (!this.records || !this.records.length);
    }
    ;
    selectReportItem(item) {
        if (item != this.selectedReportItem)
            this.reportScheduleModelToEdit = null;
        this.selectedReportItem = item;
    }
    openReportScheduleManager(item) {
        this.reportSchedulerManager.show(item.reportId, item.canBeScheduled);
    }
    isActive(item) {
        return this.selectedReportItem == item;
    }
    isParameterVisible(type) {
        var _a;
        return ((_a = this.selectedReportItem) === null || _a === void 0 ? void 0 : _a.reportType) == type;
    }
    get reportDescription() {
        var _a;
        if (!this.selectedReportItem)
            return "Select a report type.";
        return (_a = this.selectedReportItem.description) !== null && _a !== void 0 ? _a : "";
    }
    schedule(queryString) {
        var _a, _b;
        this.reportSchedulerWizard.show(new ReportScheduleModel({
            reportId: this.selectedReportItem.reportId,
            reportType: this.selectedReportItem.reportType,
            period: ((_a = this.selectedReportItem) === null || _a === void 0 ? void 0 : _a.canBeScheduled) ? ReportSchedulePeriodEnum.Daily : ReportSchedulePeriodEnum.Once,
            start: new Date(),
            query: queryString
        }), (_b = this.selectedReportItem) === null || _b === void 0 ? void 0 : _b.canBeScheduled);
    }
    updateSchedule(queryString) {
        if (!this.reportScheduleModelToEdit)
            return;
        this.working = true;
        this.reportScheduleModelToEdit.query = queryString;
        reportClient
            .updateScheduledReport(this.reportScheduleModelToEdit.id, new UpdateReportScheduleCommand({ requestModel: this.reportScheduleModelToEdit }))
            .then(() => {
            Notifier.onOk();
            this.reportScheduleModelToEdit = null;
            this.componentKey++;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    editScheduledReportFilter(model) {
        if (!model)
            return;
        this.selectedReportItem = null;
        this.selectedReportItem = this.records.find(item => item.reportId == model.reportId);
        if (!this.selectedReportItem)
            return;
        this.reportScheduleModelToEdit = model;
    }
    updateCount(reportId, count) {
        var report = this.records.find(item => item.reportId == reportId);
        if (!report)
            return;
        report.numberOfScheduledReports += count;
    }
    getNumberOfScheduledReports(item) {
        return item.numberOfScheduledReports > 99 ? "..." : item.numberOfScheduledReports;
    }
    getNumberOfScheduledReportsTitle(item) {
        return `${item.numberOfScheduledReports} reports scheduled`;
    }
};
__decorate([
    Ref("reportSchedulerManager"),
    __metadata("design:type", Object)
], ReportManagerVue.prototype, "reportSchedulerManager", void 0);
__decorate([
    Ref("reportSchedulerWizard"),
    __metadata("design:type", Object)
], ReportManagerVue.prototype, "reportSchedulerWizard", void 0);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], ReportManagerVue.prototype, "onSortChanged", null);
ReportManagerVue = __decorate([
    Component({
        name: "ReportManagerVue",
        components: {
            ReportSchedulerManagerVue,
            ReportSchedulerWizardVue,
            DashboardReportFilterVue,
            DischargeReportFilterVue,
            OhmicTrendReportFilterVue,
            DischargeActivityReportFilterVue,
            StringLifeReportFilterVue,
            BlockStatusReportFilterVue,
            StringStatusReportFilterVue,
            CompanySummaryReportFilterVue,
            SiteIssueSummaryReportFilterVue,
            CompanySystemsReportFilterVue,
            BatteryReplacementEstimationReportFilterVue
        }
    })
], ReportManagerVue);
export default ReportManagerVue;
